import * as React from "react";
import { Button} from "antd";
import { connect } from "react-redux";
//import { CopyToClipboard } from "react-copy-to-clipboard";
import { getOldHost } from "utils/tool";


interface IDiscountProps {
  id:any;
}

// 确认函
class Discount extends React.Component<IDiscountProps, any> {
  state = {
  };
  constructor(props: IDiscountProps) {
    super(props);
  }
  render() {
    let url = getOldHost()+"/report/sale_discount/addDiscount/"+this.props.id;
    return (
      <React.Fragment>
      <Button href={url} target="_blank">添加优惠</Button>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    //createLink: dispatch.orderDetails.createlink
  };
};

export default connect(
  mapState,
  mapDispatch
)(Discount);
